import ForMeToDo from "../images/projects/formetodo/ForMeToDo_LogoNoBack.svg"

const ProjectLogos = {
    ForMeToDo: ForMeToDo,
}

export default ProjectLogos